module.exports = __webpack_public_path__ + "4e4defeb74999003f439a5ef3e9a23dc.jpg";